// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-transmit-double"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M1 20H12V10H6V4H1V20Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M12 20H23V10H17V4H12V20Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 20V9L7 4H1V20H12ZM12 20H23V9L18 4H12V20ZM17 4V10H23M6 4V10H12","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M17.79 16.29L16.4972 15.0001L17.79 13.71M6.20996 16.29L7.50282 15.0001L6.20997 13.71","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-transmit-double')
export default class FileTransmitDoubleIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-transmit-double',
    }
  }
}
